<div class="loyalty-badge-wrapper px-2" data-qa="test-loyalty-badge">
  <rx-icon name="loyalty-program" fill="plum-darker" />
  <span class="f-size-xs">Loyalty</span>
</div>
